// extracted by mini-css-extract-plugin
module.exports = {"btnTab":"Style_btnTab__2x0yN","btnTitle":"Style_btnTitle__1zsUu"};